module.exports = __webpack_public_path__ + "img/share-link-img.7782eb4e.svg";